module.exports = __webpack_public_path__ + "static/media/gym.24d81d80.png";